import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from '@mui/material'
import { useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import { useNavigate, useParams } from 'react-router'
import { fetchTemplatesByType } from './api'
import LoadingScreen from '../../common/LoadingScreen/components/LoadingScreen'

export const LetterTemplatesList = () => {
  const { template_type } = useParams()
  const [templatesList, setTemplatesList] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    fetchTemplatesByType(template_type).then((res) => setTemplatesList(res))
    setIsLoading(false)
  }, [])

  const handleEdit = (templateId) => {
    navigate(`/letters_templates/edit/${templateId}`)
  }

  const handleCreate = () => {
    navigate('/letters_templates/create')
  }

  if (!templatesList || isLoading) {
    return <LoadingScreen />
  }

  return (
    <Box
      sx={{
        width: '100%',
        bgcolor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <h1>Liste des templates</h1>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        onClick={() => handleCreate()}
      >
        Créer un template
      </Button>
      <p>Choisir un template à modifier</p>
      <Box sx={{ width: '100%', maxWidth: 600, bgcolor: 'background.paper' }}>
        <nav aria-label="secondary mailbox folders">
          <List>
            {templatesList &&
              templatesList.map((template) => (
                <ListItem disablePadding key={template.id}>
                  <ListItemButton onClick={() => handleEdit(template.id)}>
                    <ListItemText primary={template.name} />
                  </ListItemButton>
                </ListItem>
              ))}
          </List>
        </nav>
      </Box>
    </Box>
  )
}
